import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { Permissao } from "app/types/Permissao";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { AgregadosContainer } from "../agregados/AgregadosContainer";
import { EstoqueContainer } from "../Estoque/EstoqueContainer";
import { LotesReservadosContainer } from "../itens-orcamento/lotes-reservados/LotesReservadosContainer";
import { LotesValidadeContainer } from "../itens-orcamento/Lotes/lotesValidadeContainer"
import { OfertasContainer } from "../itens-orcamento/ofertas/ofertasContainer";
import { TributacaoContainer } from "../itens-orcamento/tributação/TributacaoContainer";
import { TratamentoMadeiraItemContainer } from "../madeira/TratamentoMadeiraItemContainer";
import { MovimentacaoEstoqueContainer } from "../movimentacao-estoque/MovimentacaoEstoqueContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { SolicitarSenhaContainer } from "../senha/SolicitarSenhaContainer";
import { SimilaresContainer } from "../similares/SimilaresContainer";
import { SimuladorPrecoContainerDialog } from "../simulacao-preco/SimuladorPrecoContainerDialog";
import { SugerirProdutoAgregadoContainer } from "../sugerir-produto-agregado/SugerirProdutoAgregadoContainer";
import { EditarPrecoTintaContainer } from "../tinta/EditarPrecoTintaContainer";
import { UltimasComprasProdutoContainer } from "../ultimas-compras-produtos/UltimasComprasProdutosContainer";
import { MenuConsultaProdutos } from "./MenuConsultaProdutos";
import { AnaliseGerencialProdutoItemContainer } from "../AnaliseGerencialProdutoItem/AnaliseGerencialProdutoItemContainer";
import { ConsultaOrdemDeProducaoAbertoContainer } from "../ordem-producao/consulta-ordem-de-producao-aberto/ConsultaOrdemDeProducaoAbertoContainer";
// import { ServicosAgregadosContainer } from "../servicos-agregados/ServicosAgregadosContainer";

export type MenuConsulta = {
    item: IItemOrcamento;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean;
    foraOrcamento: boolean;
}

export type MenuConsultaProdutosContainerProps = {
    item: IItemOrcamento;
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    foraOrcamento: boolean;
    passos: Dict<string, () => void>;
};

declare var window: any


export const MenuConsultaProdutosContainer = (props: MenuConsultaProdutosContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>(null) 
    const [parametrosCarregados, setParametrosCarregados] = useState(false);
    const [permitidoOrdemProducao, setPermitidoOrdemProducao] = useState<boolean>(null)
    const  orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const atualizarPermissoes = async () => {
        const [
            estoque, agregados, similares, ofertas,
            lotes, lotesReservados, tributacao, movimentacao, ultimasCompras
        ] = await Promise.all([
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_ESTOQUE_PRODUTO" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_PRODUTOS_AGREGADOS" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_PRODUTOS_SIMILARES" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "OFERTAS_PRODUTO" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_LOTES_PRODUTO" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_LOTES_RESERVADOS_PRODUTO" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_INFORMACAO_TRIBUTARIA" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_MOVIMENTACAO_ESTOQUE" }),
            obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_ULTIMA_COMPRA_PRODUTO" }),
        ])
        if (!isMounted.current) return
        setPermissoes([
            // 457575 --- { Acao: "SIMULACAO_PRECO_ITEM", Permitido: await obterPermissao(...) },
            { Acao: "CONSULTAR_ESTOQUE_PRODUTO",           Permitido: estoque },
            { Acao: "CONSULTAR_PRODUTOS_AGREGADOS",        Permitido: agregados },
            { Acao: "CONSULTAR_PRODUTOS_SIMILARES",        Permitido: similares },
            { Acao: "OFERTAS_PRODUTO",                     Permitido: ofertas },
            { Acao: "CONSULTAR_LOTES_PRODUTO",             Permitido: lotes },
            { Acao: "CONSULTAR_LOTES_RESERVADOS_PRODUTO",  Permitido: lotesReservados },
            { Acao: "CONSULTAR_INFORMACAO_TRIBUTARIA",     Permitido: tributacao },
            { Acao: "CONSULTAR_MOVIMENTACAO_ESTOQUE",      Permitido: movimentacao },
            { Acao: "CONSULTAR_ULTIMA_COMPRA_PRODUTO",     Permitido: ultimasCompras },
        ])
    }

    const atualizarValoresParametros = async () => {
        const oidFilial = props?.foraOrcamento ? 0 : orcamento.OidFilialOrcamento
        const [params, paramsPorFilial] = await Promise.all([
            obterParametros({
                nomes: [
                    // por filial --"TRABALHA_TRATAMENTO_ESPECIAL_MADEIRA",
                    "CONTROLE_VALIDADE_PRODUTOS", // Empresa
                    //por filial --"TIPO_DE_CALCULO_DE_FRETE_NO_ORCAMENTO", // 433081
                ],
            }),
            obterParametrosPorOidItem({
                nomes: [
                    "TRABALHA_TRATAMENTO_ESPECIAL_MADEIRA",
                    "TIPO_DE_CALCULO_DE_FRETE_NO_ORCAMENTO", // 433081
                ],
                oidItem: oidFilial
            })
        ])
        if (!isMounted.current) return
        setParametros(params)
        setParametrosPorFilial(paramsPorFilial)
    };

    const onVerificarSeExisteOrdemProducaoConfigurada = async () => {
        var permitir = await microuniversoApi.Parametro.verificarSeExisteAlgumParametroConfigurado("UTILIZA_CONTROLE_PRODUCAO", "S")
        if (!isMounted.current) return
        setPermitidoOrdemProducao(permitir ?? false)
    }

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;
    const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor;

    const propsBase: MenuConsulta = {
        item: props.item,
        onRemover: () => removerComponenteReact("conteudo-pagina"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
        foraOrcamento: props.foraOrcamento
    }
/* 457575
    const onRenderizarConsultaSimulacaoDePreco = () => {
        const simuladorPrecoContainerDialog = <SimuladorPrecoContainerDialog
            somenteLeitura={orcamento.SomenteLeitura}
            identificadorOrcamento={orcamento.IdentificadorOrcamento}
            identificadorItem={props.item.Identificador}
            orcamentoVenda={orcamento.TipoOrcamentoDescricao == "Venda"}
            onAplicar={async () => {
                const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(orcamento.IdentificadorOrcamento)
                window.orcamentoController.model.atualizar(itensTotaisOrcamento)
                window.orcamentoController.renderizarViewItemVenda()
            }}
            onCancelar={() => window.orcamentoController.renderizarViewItemVenda()} />

        const solicitarSenhaContainer = <SolicitarSenhaContainer
            {...propsBase}
            onSenhaValidada={(senhaValida)  => {
                if (senhaValida) renderizarComponentReact(simuladorPrecoContainerDialog, "conteudo-pagina", false)
            }}
            exibirBotaoVoltar={true}
            dicaPermissao="Permissão: [Libera simulação de pesquisa de preços no orçamento]"
            permissao={"TIPO_LIBERACAO_LIBERASIMULACAOPESQUISAORC"} />

        renderizarComponentReact(solicitarSenhaContainer, "conteudo-pagina", false)
    }
*/
    const onRenderizarConsultaEstoque = () => {
        renderizarComponentReact(<EstoqueContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaAgregados = () => {
        renderizarComponentReact(<AgregadosContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaSimilares = () => {
        renderizarComponentReact(<SimilaresContainer {...propsBase} foraOrcamento={props.foraOrcamento} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaOfertas = () => {
        renderizarComponentReact(<OfertasContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaOrdemProducao = () => {
        renderizarComponentReact(<ConsultaOrdemDeProducaoAbertoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaLotesProdutos = () => {
        renderizarComponentReact(<LotesValidadeContainer {...propsBase} />, "conteudo-pagina", true);
    }
    const onRenderizarConsultaLotesProdutosReservados = () => {
        renderizarComponentReact(<LotesReservadosContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaSugerirProdutos = () => {
        renderizarComponentReact(<SugerirProdutoAgregadoContainer {...propsBase} foraOrcamento={props.foraOrcamento} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaTributacao = () => {
        renderizarComponentReact(<TributacaoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaMovimentacaoEstoque = () => {
        renderizarComponentReact(<MovimentacaoEstoqueContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarConsultaUltimasCompras = () => {
        renderizarComponentReact(<UltimasComprasProdutoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarAnaliseGerencial = () => {
        const analiseGerencialContainer = <AnaliseGerencialProdutoItemContainer
            {...propsBase}
            item={props.item}
            />

        const solicitarSenhaContainer = <SolicitarSenhaContainer
            {...propsBase}
            onSenhaValidada={senhaValida => {
                if (senhaValida) renderizarComponentReact(analiseGerencialContainer, "conteudo-pagina", false)
            }}
            exibirBotaoVoltar={true}
            dicaPermissao="Permissão: [Libera consulta da análise gerencial no orçamento]"
            permissao={"TIPO_LIBERACAO_LIBERA_CONSULTA_ANALISE_GERENCIAL"} />

        renderizarComponentReact(solicitarSenhaContainer, "conteudo-pagina", false)
    }

    const onRenderizarConsultaMedidasMadeira = () => {
        const tratamentoMadeiraContainer = <TratamentoMadeiraItemContainer item={propsBase.item}
            somenteLeitura={true}
            onOk={() => null}
            onClose={() => null} />

        propsBase.item.Madeira ?
            renderizarComponentReact(tratamentoMadeiraContainer, "conteudo-pagina", false)
            : globalMU.showWarnMessage("Produto não tem tratamento de madeira!")
    }

    const onRenderizarConsultaTinta = () => {
        renderizarComponentReact(<EditarPrecoTintaContainer {...propsBase} />, "conteudo-pagina", true);
    }

    // const onRenderizarConsultaServicosAgregados = () => {
    //     renderizarComponentReact(<ServicosAgregadosContainer {...propsBase} />, "conteudo-pagina", true);
    // }

    useEffect(() => {
        atualizarPermissoes()
        onVerificarSeExisteOrdemProducaoConfigurada()
        atualizarValoresParametros()
    }, [])

    useEffect(() => {
        if (permitidoOrdemProducao != null
                && parametrosPorFilial != null && parametrosPorFilial.length > 0
                && parametros != null && parametros.length > 0
                && permissoes != null && permissoes.length > 0
            )
        {
            setParametrosCarregados(true)
        }
    }, [permitidoOrdemProducao, parametrosPorFilial, parametros, permissoes])

    return <>
        {parametrosCarregados &&
            <MenuConsultaProdutos
                //457575 - permitirVisualiarSimulacaoDePreco={(props.item?.Identificador ?? 0) > 0 && permissoes?.find((perimissao) => perimissao.Acao == "SIMULACAO_PRECO_ITEM")?.Permitido}
                permitirVisualiarEstoque={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_ESTOQUE_PRODUTO")?.Permitido}
                permitirVisualiarAgregadosESugerirProdutos={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_PRODUTOS_AGREGADOS")?.Permitido}
                permitirVisualiarSimilares={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_PRODUTOS_SIMILARES")?.Permitido}
                permitirVisualiarOfertas={permissoes?.find((perimissao) => perimissao.Acao == "OFERTAS_PRODUTO")?.Permitido}
                permitirVisualiarLotesProdutos={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_LOTES_PRODUTO")?.Permitido}
                permitirVisualiarLotesProdutosReservados={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_LOTES_RESERVADOS_PRODUTO")?.Permitido}
                permitirVisualiarTributacao={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_INFORMACAO_TRIBUTARIA")?.Permitido}
                permitirVisualiarMovimentacaoEstoque={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_MOVIMENTACAO_ESTOQUE")?.Permitido}
                permitirVisualizarUltimasCompras={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_ULTIMA_COMPRA_PRODUTO")?.Permitido && !props.foraOrcamento}
                permitirVisualiarMedidasMadeira={(props.item?.Identificador ?? 0) > 0 && valorParametroPorFilial("TRABALHA_TRATAMENTO_ESPECIAL_MADEIRA") == "S" && !props.foraOrcamento}
                permitirVisualizarConsultaTinta={(props.item?.Identificador??0) > 0 && props.item?.IdCorTintometricoSimplicado <= 0 && (props.item?.DescricaoCorTinta ?? "") != ""} // PA 402355 repasse 311033
                permitirVisualiarAnaliseGerencial={(props.item?.Identificador ?? 0) > 0 && valorParametroPorFilial("TIPO_DE_CALCULO_DE_FRETE_NO_ORCAMENTO")?.trimEnd() == "38567" && !props.foraOrcamento} // 433081  ---  38567->Frete percentual por roteiro
                permitirVisualizarOrdemProducao={permitidoOrdemProducao}
                orcamentoControlaValidade={valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S"}
                //457575 - onRenderizarConsultaSimulacaoDePreco={onRenderizarConsultaSimulacaoDePreco}
                onRenderizarConsultaEstoque={onRenderizarConsultaEstoque}
                onRenderizarConsultaAgregados={onRenderizarConsultaAgregados}
                onRenderizarConsultaSimilares={onRenderizarConsultaSimilares}
                onRenderizarConsultaOfertas={onRenderizarConsultaOfertas}
                onRenderizarConsultaLotesProdutos={onRenderizarConsultaLotesProdutos}
                onRenderizarConsultaLotesProdutosReservados={onRenderizarConsultaLotesProdutosReservados}
                onRenderizarConsultaSugerirProdutos={onRenderizarConsultaSugerirProdutos}
                onRenderizarConsultaTributacao={onRenderizarConsultaTributacao}
                onRenderizarConsultaMovimentacaoEstoque={onRenderizarConsultaMovimentacaoEstoque}
                onRenderizarConsultaUltimasCompras={onRenderizarConsultaUltimasCompras}
                onRenderizarConsultaMedidasMadeira={onRenderizarConsultaMedidasMadeira}
                onRenderizarConsultaTinta={onRenderizarConsultaTinta}
                onRenderizarConsultaOrdemProducao={onRenderizarConsultaOrdemProducao}
                onRenderizarConsultaAnaliseGerencial={onRenderizarAnaliseGerencial} // 433081
                // onRenderizarConsultaServicosAgregados={onRenderizarConsultaServicosAgregados}
                onSelecionadoMenu={props.onSelecionadoMenu}
            />
        }
    </>
}